export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/defaultBanner.jpg?9ffd3dd4da770b988224f5ee1f502ebc";